<template>
  <feedback-table kind="idea" title="Employee Feedback" />
</template>

<script>
import FeedbackTable from './FeedbackTable'

export default {
  name: 'EmployeeFeedback',
  components: { FeedbackTable },
}
</script>
